// Module
var code = "<div class=\"search-filter-save-button\"> <div ng-click=\"model.saveFilters()\" class=\"btn btn-prim-inverse\"> Save View as Default </div> </div> ";
// Exports
module.exports = code;